<template>
  <div>


    <d-container fluid class="main-content-container px-4">

      <!-- Page Header -->
      <d-row class="page-header row no-gutters py-4">
        <d-col col sm="8" class="text-center text-sm-left mb-4 mb-sm-0">
          <span class="text-uppercase page-subtitle">iOS + Android</span>
          <h3 class="page-title">Downloads</h3>
        </d-col>
      </d-row>

    </d-container>
    <img class="download-icon" src="../assets/images/apple-appstore.png">
    <img class="download-icon" src="../assets/images/google-play-appstore.png">

<d-container fluid class="main-content-container px-4">
  <d-row>
    <d-card class="card-small">

      <!-- Form Example -->
  <d-card-header class="border-bottom">
    <h6 class="m-0">Add a User</h6>
  </d-card-header>
    <d-list-group flush>
      <d-list-group-item class="p-3">
        <d-row>
          <d-col md="12">
            <d-form>
              <d-form-row>
                <d-col md="12" class="form-group">
                  <div class="form-group">
                    <label for="feInputAddress">First Name</label>
                    <d-input id="feInputAddress" placeholder="1234 Main St" />
                  </div>
                  <div class="form-group">
                    <label for="feInputAddress">Last Name</label>
                    <d-input id="feInputAddress" placeholder="1234 Main St" />
                  </div>
                <div class="form-group">
                  <label for="feEmailAddress">Email</label>
                  <d-input id="feEmailAddress" type="email" placeholder="Email" />
                </div>
                <div class="form-group">
                  <label for="feEmailAddress">Phone Number</label>
                  <d-input id="feEmailAddress" type="phone" placeholder="Phone" />
                </div>
                </d-col>
                <div class="form-group">
                  <d-button-group class="mb-3 ml-1">
                    <d-button class="btn-primary">Storyteller</d-button>
                    <d-button class="btn-white">Admin</d-button>
                  </d-button-group>
                </div>
              </d-form-row>
              <d-form-row>
                <!--<d-col md="12" class="form-group">
                  <d-checkbox>I agree with your <a href="#">Privacy Policy</a>.</d-checkbox>
                </d-col>-->
              </d-form-row>
              <d-button type="submit">Send Invitation</d-button>
            </d-form>
          </d-col>
        </d-row>
      </d-list-group-item>
    </d-list-group>
  </d-card>
</d-row>
</d-container>

  </div>


</template>

<script>


export default {
  components: {
  },
mounted(){

}
}

</script>

<style>
.download-icon {
  width:150px;
}
</style>
